import $ from 'jquery';
import { standardizeHeights } from '../../core/INF-gridAlignment';
import { initCollectionCarousels } from './carousel';
import arrowLocation from './arrowLocation';
import themeEditor from './themeEditor';

const CollectionCarousel = () => {
  if ($('[data-collection-carousel]').length === 0) { return; }

  // First, standardize the heights
  const grid_item_selector = '[data-collection-carousel-slide]';
  const child_selectors = [
    '[data-product-tile-image]',
    '[data-product-tile-title]',
    '[data-product-tile-price]',
  ];
  
  $(window).on('resize', () => {
    standardizeHeights(grid_item_selector, child_selectors);
    arrowLocation();
  });

  // Then init the carousels
  initCollectionCarousels();
  arrowLocation();
  themeEditor();

  let previous_breakpoint = window.theme.breakpoints.current;

  $(window).on('breakpointChange', (e, breakpoint) => {
    if (breakpoint !== 'mobile' && previous_breakpoint !== 'mobile') {
      return;
    }
    
    initCollectionCarousels();
    previous_breakpoint = breakpoint;
  });
  
};

export { CollectionCarousel };